import { useMixGrouping } from "hooks/useMixGrouping";
import { useColumns } from "./EditableMixTable";
import { useFilterModel } from "./filterModel";
import { useSx } from "./sx";
import { Table } from "./Table";
import { Material, Row } from "./types";
import { PlanId } from "../boundary/PlanId";
import { useTenantData } from "contexts/tenant";
import { Period } from "hooks/periodIndex";

interface Props {
  disableEdit: boolean;
  hasEdited: boolean;
  rows: Row[];
  materials: Material[];
  selectedSteelGradeIds: number[];
  planId: PlanId;
  hasDri: boolean;
  onChange: (rows: Row[]) => void;
  setMixDescription?: (mixId: number, description: string) => void;
}

export const BackupTable = ({
  disableEdit,
  hasEdited,
  materials,
  selectedSteelGradeIds,
  rows,
  onChange,
  planId,
  hasDri,
  setMixDescription,
}: Props) => {
  const { default_mix_breakdown, small_mass_per_mass } = useTenantData();
  const massScaleFactor =
    default_mix_breakdown === "small_mass" ? small_mass_per_mass : 1;
  const massUnit =
    default_mix_breakdown === "small_mass" ? "small_mass" : "mass";
  const mixGrouping = useMixGrouping();
  const columns = useColumns(
    materials,
    selectedSteelGradeIds,
    massUnit,
    massScaleFactor,
    disableEdit,
    hasEdited,
    mixGrouping,
    hasDri,
    [],
    210,
    false,
    massUnit,
    undefined,
    setMixDescription
  );
  const filterModel = useFilterModel(planId, 1 as Period, "backup");

  const sx = useSx();
  return (
    <Table
      onChange={onChange}
      rows={rows}
      columns={columns}
      disableEdit={disableEdit}
      filterModel={filterModel}
      columnGroupingModel={[]}
      sx={sx}
      pinnedColumns={columns.slice(0, 6).map((column) => column.field)}
      columnVisibilityModel={{}}
    />
  );
};
